/** Longest question the ask route accepts; a longer one is rejected with a 400. */
export const AI_CONVO_QUESTION_MAX_LENGTH = 400;
